// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3hYPY","title":"InfoRow_title__2S9NO"};